import { useAuth0 } from '@auth0/auth0-react';
import React from 'react';
import { useHistory } from 'react-router';
import Loading from '../Utility/Loading';

const Checkout = () => {
  const { push } = useHistory();
  const { isAuthenticated, loginWithRedirect } = useAuth0();

  if (!isAuthenticated) {
    return loginWithRedirect({
      screen_hint: 'login',
    });
  }

  React.useEffect(() => {
    push('/');
  }, [push]);

  return <Loading />;
};

export default Checkout;
